import { Role } from '@guiker/permissions'

import { DocumentActions } from '../document-actions'
import { DocumentRoleNames } from '../role-names'

export const SpectatorRole: Role = {
  name: DocumentRoleNames.SPECTATOR,
  permissions: [{ action: DocumentActions.ViewDocument }],
}
